// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ew-page-top-section{width:100%;min-height:400px}.ew-page-top-section .main-image-bg{background-size:cover;width:100%;height:919px;position:relative}@media only screen and (max-width:900px){.ew-page-top-section{width:100%;min-height:400px}.ew-page-top-section .main-image-bg{background-size:cover;width:100%;height:404px;position:relative}}", ""]);
// Exports
module.exports = exports;
